// TODO RCH : maybe we should put all API calls here to make it easier
import I18n from "../utils/I18n";
import { Request } from "sp-react-commons";
import AppConfig from "AppConfig";
import getIdentityKey from "../utils/IdentityConfig";

let LoginApi = {
    loginRedirect(referrer, lang = "de") {
        return `/oauth/login?lang=${lang}&referrer=${encodeURIComponent(referrer)}`;
    }
};

let CommentApi = {
    baseUrl: `/api/v1/${I18n.lang()}/comments`,
    request: Request.enableWithCredentials(),

    commentGuidelinesUrl: `/${I18n.lang()}/imprint`, // TODO RCH

    getComment: function(commentId) {
        return this.request.get(`${this.baseUrl}/${commentId}`);
    },

    getComments: function(assetId, from = 0, pageSize = 10) {
        return this.request.get(`${this.baseUrl}/asset/${assetId}?from=${from}&pageSize=${pageSize}`);
    },

    getReplies: function(commentId) {
        return this.request.get(`${this.baseUrl}/${commentId}/replies`);
    },

    publishComment: function(appId, comment) {
        return this.request.post(`${this.baseUrl}/${appId}`, comment);
    },

    deleteComment: function(commentId) {
        return this.request.delete(`${this.baseUrl}/${commentId}`);
    }
};

let TrackingApi = {
    baseUrl: `/trk/api`,

    // Always use Tracking.track() instead of this
    track: function (action, data) {
        let url = `/api/trk?action=${action}`;
        let dataTxt = JSON.stringify(data);


        if(navigator.sendBeacon) {
            navigator.sendBeacon(url, dataTxt);
        } else {
            jQuery.ajax({
                type: "POST",
                url: url,
                contentType: "text/plain",
                data: dataTxt
            });
        }
    },

    getActiveScenario: function(id) {
        return Request.get(`${this.baseUrl}/scenarios/${id}`);
    },

    getActiveScenarios: function(editionId, scenarioType) {
        return Request.get(`${this.baseUrl}/scenarios/active/${editionId}/${scenarioType}`);
    },

    goalForScenario: function(id) {
        return Request.put(`${this.baseUrl}/scenarios/${id}`);
    }
};

const buildTrafficApi = () => ({
    baseUrl: `/api/v302/sites/${I18n.lang()}/services/traffic`,

    getParkings: function () {
        return Request.get(`${this.baseUrl}/parkings`);
    }
});

let LatinaApi = {
    baseUrl: `/api/v1/sites/pt/latina`,
    playerUrl: '/pt/latina/player',

    getPlaylist: function() {
        return Request.get(`${this.baseUrl}/playlist`);
    },

    playlistUpdates: function() {
        return new WebSocket(`${AppConfig.latinaWebsocketHost}${this.baseUrl}/playlistUpdates`);
    }
};

const buildAnnouncementApi = () => ({
    baseUrl: `/api/v304/${I18n.lang()}/services`,

    getAnnouncements: function (announcementType) {
        return Request.get(`${this.baseUrl}/announcements/${announcementType}`);
    },

    getAnnouncement: function (announcementId) {
        return Request.get(`${this.baseUrl}/announcement/${announcementId}`);
    }
});

const buildSportResultsApi = () => ({
    baseUrl: `/api/v302/sites/${I18n.lang()}/services/sports`,

    getSportsWithLeaguesAndDivisions: function() {
        return Request.get(this.baseUrl);
    },

    getDayMatches: function(divisionId, matchDay) {
        return Request.get(`${this.baseUrl}/divisions/${divisionId}/matchdays/${matchDay}`)
    },

    getRanking: function(divisionId) {
        return Request.get(`${this.baseUrl}/divisions/${divisionId}/ranking`)
    }
});

let HomeApi = {
    baseUrl: `/api/${I18n.lang()}/home`,

    getUpdates: function (version) {
        return Request.get(`${this.baseUrl}/updates?&version=${version}`)
    }
};

let PnsNotificationsApi = {
    baseUrl: `/api/web/500`,

    subscribeToPnsNotifications: function(token, data) {
        return Request.post(`${this.baseUrl}/device_tokens/${token}`, data)
    },

    getPnsToken: function (token, applicationId) {
        return Request.get(`${this.baseUrl}/token/${token}/${applicationId}`)
    }
};

const buildChartApi = () => ({
    baseUrl: `${getIdentityKey("webHost")}/api/v1/${I18n.lang()}/articles`,

    getChart: function (contentId, chartId) {
        return Request.get(`${this.baseUrl}/${contentId}/charts/${chartId}`);
    },

    getMap: function (mapType) {
        return Request.get(`${getIdentityKey("webHost")}/assets/javascripts/maps/${mapType}.json`)
    }
});

export { LoginApi, CommentApi, LatinaApi, buildTrafficApi, buildAnnouncementApi, buildSportResultsApi, TrackingApi, HomeApi, buildChartApi, PnsNotificationsApi }



// WEBPACK FOOTER //
// ./js/api/Api.js